import { apiCall, ApiConfig } from '../../config/api'
import { getFlowsAction } from '../actions/flowActions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { Flow } from '../../interfaces/Flow'
import { GET_FLOW } from '../types/flowActionsTypes'

export function* getFlowsAsync() {
  try {
    const { status, data }: AxiosResponse<Flow[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.FlowApi}`
    )
    if (status === 200) {
      yield put(getFlowsAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getFlowsAction([], serverError.message))
  }
}

export function* watchGetFlowsAsync() {
  yield takeEvery(GET_FLOW, getFlowsAsync)
}
